<template>
  <!-- 基本设置 -->
  <div class="base_wrap">
    <h3>{{ $t('myAccount.menu[0]') }}</h3>
    <a-form :form="baseForm" @submit="handleSubmit" class="base_form" >
      <a-form-item :label="`${ $t('myAccount.formItem[0]') }`" >
        <a-input v-decorator="formRule.industry" />
      </a-form-item>
      <a-form-item :label="`${ $t('myAccount.formItem[1]') }`" >
        <a-input v-decorator="formRule.alias" :maxLength="20"/>
      </a-form-item>
      <a-form-item :label="`${ $t('myAccount.formItem[2]') }`" >
        <a-input v-decorator="formRule.company" />
      </a-form-item>
      <a-form-item :label="`${ $t('myAccount.formItem[3]') }`" >
        <a-input v-decorator="formRule.area" />
      </a-form-item>
      <a-form-item :label="`${ $t('myAccount.formItem[4]') }`" >
        <a-input v-decorator="formRule.addr" />
      </a-form-item>
      <a-form-item :label="`${ $t('myAccount.formItem[5]') }`" >
        <a-input v-decorator="formRule.phone" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" :loading="btnLoading">{{ $t('myAccount.submit') }}</a-button>
      </a-form-item>
    </a-form>
    <!-- 上传头像 -->
    <div class="img_head">
      <div @mouseenter="isShow = true" @mouseleave="isShow = false" @click="$refs.uploadInput.click()">
        <img :src="headImg" :key="headImg" v-if="headImg">
        <img src="../../assets/images/default_user.png" key="default" v-else>
        <img src="../../assets/images/head_panel.png" class="img_mask" v-if="isShow">
      </div>
      <p v-if="isShow">{{ $t('myAccount.upHead') }}</p>
      <input type="file" ref="uploadInput" @change="chooseFile" style="opacity: 0;" accept="image/*"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { apiMy } from '@/api/my'

export default {
  computed: {
    ...mapGetters(['userInfo']),
    formRule () {
      const info = JSON.parse(this.userInfo || '{}')
      const rule = {
        industry: [
          'custIndustry',
          {
            initialValue: info.custIndustry || ''
          }
        ],
        alias: [
          'custAlias',
          {
            initialValue: info.custAlias || '',
            rules: [
              // { pattern: new RegExp(/[^艺赛旗]/g), message: 'aa' }
            ]
          }
        ],
        company: [
          'custCompany',
          {
            initialValue: info.custCompany || ''
          }
        ],
        area: [
          'custArea',
          {
            initialValue: info.custArea || ''
          }
        ],
        addr: [
          'custAddr',
          {
            initialValue: info.custAddr || ''
          }
        ],
        phone: [
          'custContact',
          {
            initialValue: info.custContact || '',
            rules: [
              { pattern: new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/), message: this.$t('myAccount.tipPhone') }
            ]
          }
        ]
      }
      return rule
    }
  },
  data () {
    return {
      isShow: false,
      headImg: '',
      baseForm: this.$form.createForm(this),
      btnLoading: false
    }
  },
  created () {
    this.headImg = JSON.parse(this.userInfo || '{}').custImage
  },
  methods: {
    // 提交
    handleSubmit (e) {
      e.preventDefault()
      this.baseForm.validateFields((err, formVals) => {
        if (!err) {
          if (formVals.custAlias && formVals.custAlias.indexOf('艺赛旗') !== -1) {
            this.$message.error(this.$t('myAccount.NickName'))
            return
          }
          this.btnLoading = true
          const info = JSON.parse(this.userInfo || '{}')
          const obj = Object.assign({}, formVals, { custNo: info.custNo })
          apiMy.base(obj).then(data => {
            for (const key in formVals) {
              if (key) {
                info[key] = formVals[key]
              }
            }
            this.btnLoading = false
            this.$message.success(this.$t('msg.modifyOk'))
            this.$store.commit('updateUserInfo', JSON.stringify(info))
          })
        }
      })
    },
    chooseFile () {
      const file = this.$refs.uploadInput.files[0]
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error(this.$t('myAccount.tipUpload'))
        return
      }
      const formData = new FormData()
      formData.append('avatar', file)
      apiMy.uploadHead(formData).then(data => {
        this.headImg = data
        const info = JSON.parse(this.userInfo || '{}')
        info.custImage = data
        this.$store.commit('updateUserInfo', JSON.stringify(info))
        this.$message.success(this.$t('msg.uploadSucess'))
      }).catch(err => {
        if (err.msg) {
          this.$message.error(err.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.base_wrap {
  position: relative;
  h3 {
    font-weight: bold;
    padding: 10px 0;
    margin-bottom: 20px;
  }
  .base_form {
    width: calc( 100% - 200px);
  }
  .img_head {
    width: 180px;
    height: 180px;
    position: absolute;
    top: 65px;
    right: 10px;
    text-align: center;
    & >  div {
      width: 100%;
      height: 100%;
      position: relative;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid #eee;
      }
      .img_mask {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    p {
      margin-top: 10px;
      color: #4977FC;
    }
  }
}
</style>
